import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch } from "react-redux";
import { formatDate } from "../../../utils";
import { Close } from "@mui/icons-material";
import toast from "react-hot-toast";
import { getUnlistedInventory } from "../../../redux/rm/rmSlice";

const RMUnlistedInventory = () => {
  const dispatch = useDispatch<any>();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [inventory, setInventory] = useState<any[]>([]);
  const [showAddStockModal, setShowAddStockModal] = useState<boolean>(false);
  const [assignModalOpen, setAssignModalOpen] = useState<boolean>(false);
  const [formData, setFormData] = useState<any>({
    stockName: "",
    totalQuantity: "",
    price: "",
  });

  const [assignData, setAssignData] = useState<any>({
    rmId: "",
    quantity: "",
  });

  const [currentData, setCurrentData] = useState<any>(null);
  const [rms, setRms] = useState<any[]>([]);

  useEffect(() => {
    fetchInvenotory();
    // fetchRms();
  }, []);

  // const fetchRms = async () => {
  //   try {
  //     const response = await dispatch(
  //       getRMUser({
  //         userType: 2,
  //         pageIndex: 1,
  //         pageSize: 1000,
  //       })
  //     );
  //     const data = response.payload.data;
  //     setRms(data);
  //   } catch (error) {
  //     console.error("Error fetching user data:", error);
  //   }
  // };


  const fetchInvenotory = async () => {
    const response = await dispatch(getUnlistedInventory({}));
    if (response?.error?.message) {
      console.error(
        "Error fetching unlisted inventory:",
        response.error.message
      );
      return;
    }
    setInventory(response.payload.data || []);
  };

  // const handleAddStock = async () => {
  //   try {
  //     const response = await dispatch(
  //       addUnlistedInventory({
  //         ...formData,
  //       })
  //     );
  //     if (response?.error?.message) {
  //       toast.error("Error adding stock.");
  //       return;
  //     }

  //     toast.success("Stock added successfully.");
  //     setShowAddStockModal(false);
  //     fetchInvenotory();
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  // const handleAssignToRM = async () => {
  //   try {
  //     const response = await dispatch(
  //       assignUnlistedInventory({
  //         ...assignData,
  //         inventoryId: currentData?.id,
  //       })
  //     );
  //     if (response?.error?.message) {
  //       toast.error("Error assigning stock to RM.");
  //       return;
  //     }

  //     toast.success("Stock assigned to RM successfully.");
  //     setAssignModalOpen(false);
  //     fetchInvenotory();
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };

  return (
    <div
      className="min-h-screen bg-lightBg py-8 px-4 sm:px-6 lg:px-8"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <Box
        width="90%"
        mb={2}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography variant="h5" style={{ textAlign: "left" }}>
          Unlisted Inventory
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setShowAddStockModal(true)}
        >
          Create Order
        </Button>
      </Box>
      <Box
        width="90%"
        mb={2}
        sx={{ display: "flex", justifyContent: "flex-start" }}
      >
        <div style={{ position: "relative", width: "800px" }}>
          {" "}
          {/* Set width of the input */}
          <input
            type="text"
            placeholder="Search Inventory" // Add placeholder
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: "100%",
              padding: "10px 20px 10px 45px", // Increase left padding for the icon
              borderRadius: "5px",
              border: "1px solid #ccc",
              fontSize: "16px",
            }}
          />
          {/* Add search icon */}
          <SearchIcon
            style={{
              position: "absolute",
              top: "50%",
              left: "15px", // Position the icon closer to the left side
              transform: "translateY(-50%)",
              color: "#888",
            }}
          />
        </div>
      </Box>
      <div style={{ display: "flex", justifyContent: "center", width: "90%" }}>
        <TableContainer
          component={Paper}
          style={{ width: "100%", marginTop: "2rem" }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Name
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Total Quantity
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Available Quantity
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Price
                </TableCell>
                <TableCell style={{ fontWeight: "bold", minWidth: 120 }}>
                  Assigned Date
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {inventory &&
                inventory?.map((stock, index) => (
                  <TableRow key={index}>
                    <TableCell>{stock?.stockName}</TableCell>
                    <TableCell>{stock?.assignedQuantity}</TableCell>
                    <TableCell>{stock?.availableQuantity}</TableCell>
                    <TableCell>{stock?.price}</TableCell>
                    <TableCell>{formatDate(stock?.assignedDate)}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
            {/* <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  count={totalPages * pageSize} // Total number of rows
                  rowsPerPage={pageSize}
                  page={currentPage - 1} // Page is zero-indexed
                  onPageChange={onPageChange}
                  onRowsPerPageChange={onPageSizeChange}
                  labelDisplayedRows={({ from, to, count }) =>
                    `${currentPage} – ${totalPages} `
                  }
                />
              </TableRow>
            </TableFooter> */}
          </Table>
        </TableContainer>
      </div>
      {/* Assign to RM Modal */}
    </div>
  );
};

export default RMUnlistedInventory;
